import url from 'url';
import { createAction, createReducer } from 'redux-act';
import { selectCurrentId } from '@gandi/redux-sharing';
import { createResource } from '@gandi/resource/redux';
import { selectRaw } from './utils';
export const resource = createResource('billing.money.pay');
export const preparePSPCall = ({
  mean: {
    pay_url: payUrl,
    provider,
    code,
    key
  },
  order: {
    id: session
  },
  locale: lang,
  returnUrl,
  sharingId,
  context,
  label
}) => dispatch => {
  return dispatch(resource.createOne(payUrl, {
    paylabel: `${session}-${provider}-${code}${key ? `-${key}` : ''}-${lang}`,
    session,
    lang,
    return_url: returnUrl
  }, {
    label: label || `${session}.${sharingId}.${context}`,
    params: {
      sharing_id: sharingId
    },
    on200: response => response,
    not200: response => Promise.reject(response)
  }));
};
export const selectPSPCallParams = (state, options) => selectRaw(state).money[options.label];

/* -------------- Deprecation in progress ------------------------ */

export const extractPaymentParameters = value => {
  const [provider, code, key] = value.split('-');
  const paymentProductId = key.split(provider)[1] || key.split(code)[1];
  return {
    // $FlowFixMe[incompatible-return] - no real way to check this kind of value.
    provider,
    // $FlowFixMe[incompatible-return] - no real way to check this kind of value.
    code,
    key,
    paymentProductId: paymentProductId ? parseInt(paymentProductId, 10) : undefined
  };
};

// $FlowFixMe[unclear-type]
export const setPaymentCallParams = createAction('[billing.money.setPaymentUrl] Store payment URL & params');
export const selectIsPaying = (state, {
  sharingId,
  orderId
}) => resource.selectIsCreatingOne(state, `${sharingId}.${orderId}`);
export const selectPaymentCallParams = state => selectRaw(state).money.paymentCallParams;

/**
 * Perform a payment for a given orderId (= session(id))
 * dispatch(
 *  pay({ provider: 'gandi', code: 'prepaid', locale: 'en', orderId: 424242 }, { sharingId? })
 * )
 */
export const pay = (params, options = {
  sharingId: undefined,
  params: undefined
}) => (dispatch, getState) => {
  const sharingId = options.sharingId || selectCurrentId(getState());
  if (typeof sharingId !== 'string') {
    return Promise.reject(new Error('[billing.money] `pay` called without `sharingId` option' + ' nor @gandi/redux-sharing dep/state.'));
  }
  const {
    label,
    orderId,
    provider,
    code,
    key,
    locale,
    returnUrl
  } = params;
  const paymentUrl = url.parse(params.saveUrl || params.payUrl);

  /* because of pyramid, backend cannot get rid of the baseurl, this is the best workaround i found
    pay_url: https://shop.stage.gandi.net/api/v5/money/pay/gc/cc/3?flush_prepaid=1 -> /money/pay/gc/cc/3?flush_prepaid=1
    save_url: https://admin.stage.gandi.net/billing/api/v5/money/api/v5/mycards/gc/cc/1 -> /mycards/gc/cc/1
  */

  // $FlowFixMe[incompatible-use] - pathname is not null
  // $FlowFixMe[incompatible-type]
  const endpoint = `${paymentUrl.pathname.split('/api/v5').pop()}`;
  const extraParams = paymentUrl.query ? Object.fromEntries(new URLSearchParams(paymentUrl.query)) : {};
  const body = {
    paylabel: label || `${orderId}-${provider}-${code}${key ? `-${key}` : ''}-${locale}`,
    session: orderId,
    lang: locale,
    return_url: returnUrl,
    order_id: orderId
  };
  const resourceLabel = `${sharingId}.${orderId}`;
  return dispatch(
  // $FlowFixMe[incompatible-call]
  resource.createOne(endpoint, body, {
    ...options,
    label: resourceLabel,
    params: {
      // $FlowFixMe[exponential-spread]
      ...(options.params || {}),
      sharing_id: sharingId,
      ...extraParams
    },
    on2XX: response => response,
    not2XX: response => Promise.reject(response)
  }));
};
/* --- end Deprecation in progress part ------- */

// $FlowFixMe[unclear-type]
const reducer = createReducer({
  [resource.createOne.success.getType()]: (state, {
    response: {
      data
    }
  }, {
    label
  }) => ({
    ...state,
    [label]: data
  }),
  [setPaymentCallParams]: (state, payload) => ({
    ...state,
    // ensure no dropin in legacy state.
    paymentCallParams: !!payload.url && payload
  })
}, {});
export default reducer;